export * from './procedures';
export * from './accessGroups';
export * from './permissions';
export * from './address';
export * from './clients';
export * from './company';
export * from './mail';
export * from './users';
export * from './convenats';
export * from './financialPlans';
export * from './terminologies';
export * from './taxes';
export * from './specialties';
export * from './schedules';
export * from './schedulesStatus';
export * from './professionals';
export * from './paymentsMethods';
export * from './guides';
export * from './guidesStatus';
export * from './guidesLogs';
export * from './treatments';
export * from './treatmentsItems';
export * from './treatmentsPayments';
export * from './dentaltreatments';
export * from './dentalTreatmentsItems';
export * from './dentalTreatmentsPayments';
export * from './products';
export * from './sales';
export * from './productsCategories';
export * from './holidays';
export * from './whatsapp';
export * from './crm';
